import { createFileRoute } from '@tanstack/react-router'

import EditPenyuluhPage from '@/components/pages/backoffice/_klb-penyuluh/_desa/containers/EditPage'

export const Route = createFileRoute(
  '/_backoffice/klb-penyuluh/desa/$penyuluhId/edit'
)({
  component: EditPenyuluhPage
})
